import { useReducer } from 'react';

export default function useForceUpdate() {
  return useReducer(() => ({}), {})[1] as () => void;
}
